/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Chain_To_Previous_EventInputs */



/**
* | output |
* | --- |
* | "Snap the Event incode to the previous Event's outcode" |
*
* @param {Shortcut_Keys_Desc_Chain_To_Previous_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_chain_to_previous_event = /** @type {((inputs?: Shortcut_Keys_Desc_Chain_To_Previous_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Chain_To_Previous_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Accrocher l'incode de l'evenement a l'outcode de l'evenement precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ordnen Sie den Ereignis-Incode dem Outcode des vorherigen Ereignisses zu.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Collega l'incode dell'evento all'outcode dell'evento precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сопоставьте код входящего сигнала события с кодом исходящего сигнала предыдущего события.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ajustar el código de entrada del evento al código de salida del evento anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将事件的输入代码与前一个事件的输出代码对齐。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントのインコードを前のイベントのアウトコードにスナップします")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट इनकोड को पिछले इवेंट के आउटकोड से स्नैप करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sincronizar o código de entrada do evento com o código de saída do evento anterior.")
	return /** @type {LocalizedString} */ ("Snap the Event incode to the previous Event's outcode")
});